<div mat-dialog-title>
  {{ 'common.ticketPublishConfirmDialog.titles.issuedComplete' | translate }}
</div>
<div mat-dialog-content>
  <div>
    {{ data.message | translate }}
  </div>
  <mat-checkbox color="primary" class="checkbox" [(ngModel)]="preserveFormData">
    {{ 'common.ticketPublishConfirmDialog.messages.noReset' | translate }}
  </mat-checkbox>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="close()">
    {{ 'common.actions.ok' | translate }}
  </button>
</div>
